import axios from 'axios';

const token = localStorage.getItem('token');
let headers = {}

if (token != null) {
    
}

let env = process.env.NODE_ENV
const getBaseUrl = (env) => {

    switch (env) {
        case process.env.REACT_APP_STAGING_HOST:
            return process.env.REACT_APP_STAGING_BASE_URL
        case process.env.NODE_ENV:
            return process.env.REACT_APP_LOCAL_BASE_URL
        case process.env.REACT_APP_DEV_HOST_NAME:
            return process.env.REACT_APP_DEV_BASE_URL
        case process.env.REACT_APP_PROD_HOST:
            return process.env.REACT_APP_PROD_BASE_URL
        default:
            return process.env.REACT_APP_LOCAL_BASE_URL

    }
}

const instance = axios.create({
 baseURL: getBaseUrl(window.location.hostname),
    headers: headers
});

export default instance;